import {extend} from "vee-validate";

function dateConverter(value){
    if(_.isString(value) || DateTime.isDateTime(value)){
        return _.isString(value) ? DateTime.fromFormat(value,'dd/MM/yyyy') : value;
    }

    throw new Error(value + " need to be dd/mm/yyyy or a DateTime instance");
}

extend('before',{
    params: ['before'],
    validate:(value, { before })=>{
        if(_.isDate(value)) {
            value = DateTime.fromJSDate(value)
            before = dateConverter(before)
        }

        return value<before;
    },
})

extend('before_or_equal',{
    params: ['before'],
    validate:(value, { before })=>{
        if(_.isDate(value)) {
            value = DateTime.fromJSDate(value)
            before = dateConverter(before)
        }

        return value<=before;
    },
})

extend('after',{
    params: ['after'],
    validate:(value, { after })=>{
        if(_.isDate(value)) {
            value = DateTime.fromJSDate(value)
            after = dateConverter(after)
        }

        return value>after;
    },
})

extend('after_or_equal',{
    params: ['after'],
    validate:(value, { after })=>{
        if(_.isDate(value)) {
            value = DateTime.fromJSDate(value)
            after = dateConverter(after)
        }

        return value>=after;
    },
})
